import { LocationNumbersService } from '../../../services'

const linkAddressOrBundleSid = async function ({ dispatch, state }, config) {
  const { payload } = config
  const locationId = payload.locationId
  try {

    const data = await LocationNumbersService.linkAddressOrBundleSid(
      payload
    )

    await dispatch('fetchLocationTwilio', locationId)
    await dispatch('fetchPhoneNumbers', {
      locationId: locationId,
      getPaginatedDataOnly: false,
      payload: {
        limit: state.table?.limit,
        page: state.table?.currentPage,
        query: state.table?.searchText ?? '',
      },
    })
    return data
  } catch (error) {
    throw error
  }
}

export default linkAddressOrBundleSid
